<template>
  <form v-on:submit.prevent="submitSearch" class="uk-width-1-1 uk-search uk-search-default uk-align-center">
    <input class="search-box uk-search-input" type="search"
           :placeholder=placeholderText v-model="searchText" autocomplete="off" required id="Search">
    <router-link :to="{name: 'Search', query:{searchText:dirtyText, key: new Date().getTime()}}">
    <img class="uk-search-icon-flip" :src=searchIcon>
    </router-link>
  </form>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'

  export default {
    name: 'search-box',
    data() {
      return {
        dirtyText: null,
        searchIcon: iconUtil.resolve(misc.SEARCH_ICON),
        placeholderText: this.$t('general.searchForResources')
      }
    },
    computed: {
      ...mapGetters(['searchTerm']),
      searchText: {
        get: function () {
          return this.searchTerm
        },
        set: function (newVal) {
          this.setSearchCriteria({searchText: newVal})
          this.dirtyText = newVal
        }
      }
    },
    methods: {
      ...mapActions(['performSearch', 'setSearchCriteria']),
      removeSearchText() {
        this.searchText = null
      },
      submitSearch() {
        this.performSearch({searchText: this.dirtyText})
        this.dirtyText = null
      }
    },
    watch: {
      searchTerm(value) {
        this.searchText = value
      }
    },
    mounted() {
      this.searchText = this.searchTerm
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  form {
    position: relative;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
  }

  .uk-search-icon-flip {
    z-index: 2;
    position: absolute;
    margin-top: 15px;
    width: 52px;
    height: 53px;
  }

  .uk-search-default .search-box {
    height: 86px;
    width: 538px;
    font-size: 24px;
    opacity: 0.75;
    position: absolute;
    background-color: white;
    padding-left: 25px;
    margin-top: 0px;
  }

  .uk-search-default {
    height: 86px;
    width: 597px;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 0;

    .uk-search-input {
      border: 0px solid #e5e5e5;
    }
  }

  input::placeholder {
    color: $slate !important;
    padding-right: 12px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .uk-search-default .search-box {
      width: 550px;
      height: 67px;
      font-size: 20px;
    }

    .uk-search-default {
      width: 550px;
      height: 67px;
    }
    .uk-search-icon-flip {
      margin-top: 7px;
    }
  }

  @media screen and (max-width: $breakpoint-medium + 60) {
    .uk-search-default .search-box {
      width: 500px;
      height: 67px;
      font-size: 20px;
    }

    .uk-search-default {
      width: 500px;
      height: 67px;
    }
    .uk-search-icon-flip {
      margin-top: 7px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .uk-search-default .search-box {
      height: 48px;
      font-size: 14px;
      padding-left: 15px;
      width: 282px;
    }

    .uk-search-default {
      height: 48px;
      width: 282px;
    }
    .uk-search-icon-flip {
      margin-top: 0;
      width: auto;
      height: auto;
    }
  }

</style>
